<template src="./AddUpdateModule.html"></template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";

import { Input } from "@progress/kendo-vue-inputs";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import SelectFeatureTemplate from "@/components/CommandCellTemplate/SelectFeatureTemplate";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("packageModules");
import { notifyWarn } from "@/utils/notification-helper"
// import { orderBy } from "@progress/kendo-data-query";

Vue.component("dropdownlist", DropDownList);
Vue.component("k-input", Input);
Vue.use(VueRouter);

export default {
  props: {
    Name: String,
    ID: String,
    features: Array
  },
  data: function() {
    return {
      skip: 0,
      take: 10,
      pageSize: 10,
      modulename: "",
      columns: [
        { cell: SelectFeatureTemplate, title: "SELECT", width: "70px" },
        { field: "id", hidden: true, title: "ID" },
        { field: "name", title: "NAME" },
        { field: "type", hidden: true, title: "TYPE" }
      ],
      dataItem: [],
      userInputs: {}
    };
  },
  methods: {
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    getDataOnload: function() {
      this.$store.dispatch("packageModules/getFetaureList");
    },
    goToListPage: function() {
      this.$router.push({ name: "PackageModule" });
    },
    addModules: async function() {
      var inputElements = document.getElementsByClassName("checkBoxcss");
      var checkedValue = [];

      for (var i = 0; i < inputElements.length; ++i) {
        if (inputElements[i].checked) {
          checkedValue.push({
            ID: Number(inputElements[i].value)
          });
        }
      }
      if (this.modulename != "") {
        if (checkedValue.length > 0) {
          await this.$store.dispatch(
            "packageModules/createNewModule",
            {
              Name: this.modulename,
              features: checkedValue
            }
          );
         this.$router.push({ name: "PackageModule" });
        } else {
          notifyWarn("Select feature!")
        }
      } else {
        notifyWarn("Module name is required.")
      }
    }
  },
  computed: {
    ...mapState({
      feature: state => state.features
    }),
    total() {
      return this.feature.length;
    },
    items: {
      get: function() {
        // return orderBy(
        return this.feature.slice(this.skip, this.take + this.skip);
        // this.sort
        //  );
      }
    }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>

<style scoped>
.checkBoxcss {
  margin: 11px;
}
</style>